import { useNavigate } from "react-router-dom";

function EntryPage() {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col mt-12 w-full gap-7 items-center">
      <h1 className="text-[#3B4F67] text-xl text-center md:text-2xl mb-4">
        سلام خوش آمدید!
      </h1>

      <button
        className="text-[#FFFFFF] bg-[#39A78E] hover:bg-[#2A7A67] px-12 py-2 text-[20px]  font-semibold tracking-tighter rounded-xl   "
        onClick={() => navigate("/login")}
      >
        ورود به پنل کاربری
      </button>
    </div>
  );
}

export default EntryPage;
